
// Manages game lifecycle events like starting, pausing, and ending
import { 
  initializeBoard, 
  createBlock, 
  canMoveTo, 
  lockBlock, 
  clearLines, 
  isGameOver 
} from './gameState';
import { GAME_CONFIG } from './gameConfig';
import { startDropTimer, calculateLinesClearedPoints } from './scoreManager';
import { createGameOverDisplay, createPauseDisplay, drawBoard } from './renderer';

export function endGame(scene) {
  scene.isGameActive = false;
  
  // Stop the drop timer
  if (scene.dropTimer) {
    scene.dropTimer.destroy();
    scene.dropTimer = null;
  }
  
  // Show game over screen
  scene.gameOverDisplay = createGameOverDisplay(scene);
  
  // Add restart handler
  scene.input.once('pointerdown', scene.restartGame, scene);
}

export function restartGame(scene) {
  // Clean up game over display
  if (scene.gameOverDisplay) {
    scene.gameOverDisplay.overlay.destroy();
    scene.gameOverDisplay.gameOverText.destroy();
    scene.gameOverDisplay.finalScoreText.destroy();
    scene.gameOverDisplay.restartText.destroy();
    scene.gameOverDisplay = null;
  }
  
  // Reset game state
  scene.board = initializeBoard();
  scene.score = 0;
  scene.level = 1;
  scene.linesCleared = 0;
  scene.dropSpeed = GAME_CONFIG.initialSpeed;
  
  // Reset UI
  scene.ui.scoreText.setText('Score: 0');
  scene.ui.levelText.setText('Level: 1');
  scene.ui.linesText.setText('Lines: 0');
  
  // Clear graphics
  if (scene.boardGraphics) {
    scene.boardGraphics.forEach(graphic => graphic.destroy());
  }
  scene.boardGraphics = [];
  
  // Create new block
  scene.currentBlock = createBlock(scene);
  scene.drawBlock(scene, scene.currentBlock);
  
  // Restart the game
  scene.isGameActive = true;
  startDropTimer(scene);
}

export function lockCurrentBlock(scene) {
  // Lock the current block in place
  scene.board = lockBlock(scene, scene.board, scene.currentBlock);
  
  // Check for completed lines
  const result = clearLines(scene, scene.board);
  scene.board = result.board;
  const linesCleared = result.linesCleared;
  
  if (linesCleared > 0) {
    // Update lines cleared count
    scene.linesCleared += linesCleared;
    scene.ui.linesText.setText(`Lines: ${scene.linesCleared}`);
    
    // Award points for clearing lines
    const points = calculateLinesClearedPoints(linesCleared, scene.level);
    scene.updateScore(points);
    
    // Check for level up (every 10 lines)
    const newLevel = Math.floor(scene.linesCleared / 10) + 1;
    if (newLevel > scene.level) {
      scene.levelUp(newLevel);
    }
  }
  
  // Redraw the board with locked block
  drawBoard(scene, scene.board);
  
  // Check for game over
  if (isGameOver(scene.board)) {
    scene.endGame();
    return;
  }
  
  // Create a new block
  scene.currentBlock = createBlock(scene);
  scene.drawBlock(scene, scene.currentBlock);
  
  // Check if the new block can fit
  if (!canMoveTo(scene.board, scene.currentBlock, 0, 0)) {
    scene.endGame();
  }
}
